import React from 'react';
import {HistoryMarketType} from '../../../types/MyDynamicsData';
import {useGetHistoryMarketplanQuery} from '../../../redux/myDynamicApi';
import Loader from '../../../assets/Animations/PreLoaderComponent/Loader';
import {useTranslation} from 'react-i18next';

const HistoryMarketplan: React.FC = () => {
	const {t} = useTranslation();
	const {data, isLoading} = useGetHistoryMarketplanQuery();
	if (isLoading) return <Loader />;
	if (data) {
		return (
			<div className="history__column">
				<div className="history__title name">{t('Історія маркетингплану')}</div>
				{data.mp.map((p: HistoryMarketType, index: number) => (
					<div className="history__item" key={p.end_date + index}>
						<div className="history__date">
							{t('з {{from}} до {{to}}', {
								from: p.start_date,
								to: p.end_date,
							})}
						</div>
						<div className="history__label">{p.mp_name}</div>
					</div>
				))}
			</div>
		);
	} else return null;
};

export default HistoryMarketplan;
